module.exports = {
  CANDIDATE: "CANDIDATE",
  SEARCH: "SEARCH",
  JOB_PROFILE: "JOB_PROFILE",
  SKILL: "SKILL",
  DEGREE_SUGGESTION: "DEGREE_SUGGESTION",
};
